import React from "react";
import "./../styles/root.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 TuneParams.ai. All rights reserved.</p>
    </footer>
  );
};

export default Footer;